import { Navigate } from 'react-router-dom';
import config from '../config';

function PrivateRoute({ children }) {
   const token = localStorage.getItem(config.token_name) || sessionStorage.getItem(config.token_name);

  return token ? children : <Navigate to="/login" replace />
}

export default PrivateRoute;